import React from 'react'
import teamImg1 from '../images/team/Elizabeth-Profile_copy.jpg'
import teamImg2 from '../images/team/t1.jpg'
import teamImg3 from '../images/team/t2.jpg'
import { FaInstagram, FaFacebook } from 'react-icons/fa';
 
import { FaXTwitter } from "react-icons/fa6";

const OurTeam = () => {
  return (
   <section id="our-team" className="our-team section">
   
     <div className="container">
   
       {/* Section Title */}
       <div className="section-title text-center" data-aos="fade-up">
         <span className="subtitle" data-reveal>Our People</span>
         <h3 data-reveal >Meet the Team</h3>
       </div>
       
   
       <div className="row gy-4 mt-3">
   
         {/* Team Member 1 */}
         <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100" data-reveal>
           <div className="team-card" >
             <div className="team-image">
               <img src={teamImg1} alt="Elizabeth Nganga" />
             </div>
             <div className="team-content">
               <h4>Elizabeth Nganga</h4>
               <span className="role">Founder & Executive Director</span>
               <div className="team-social">
                 <a href="#"><FaInstagram size={20} /></a>
                 <a href="#"><FaFacebook size={20} /></a>
                 <a href="#"><FaXTwitter size={20} /></a>
               </div>
             </div>
           </div>
         </div>
   
         {/* Team Member 2 */}
         <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200" data-reveal>
           <div className="team-card">
             <div className="team-image">
               <img src={teamImg2} alt="Program Manager" />
             </div>
             <div className="team-content">
               <h4>Jacqueline Njeri</h4>
               <span className="role">Program Manager</span>
               <div className="team-social">
                 <a href="#"><FaInstagram size={20} /></a>
                 <a href="#"><FaFacebook size={20} /></a>
                 <a href="#"><FaXTwitter size={20} /></a>
               </div>
             </div>
           </div>
         </div>
   
         {/* Team Member 3 */}
         <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300" data-reveal>
           <div className="team-card">
             <div className="team-image">
               <img src={teamImg3} alt="Community Lead" />
             </div>
             <div className="team-content">
               <h4>Patricia Kiarie</h4>
               <span className="role">Finance & Administration</span>
               <div className="team-social">
                 <a href="#"><FaInstagram size={20} /></a>
                 <a href="#"><FaFacebook size={20} /></a>
                 <a href="#"><FaXTwitter size={20} /></a>
               </div>
             </div>
           </div>
         </div>
   
       </div>
   
     </div>
   
   </section>
  )
}

export default OurTeam